/**
 * Created by Nisarg on 7/19/2017.
 */
import React, {Component} from 'react';
import {ModalContainer, ModalDialog} from 'react-modal-dialog';

import $ from 'jquery';
import firebase from 'firebase';

import _HauteFire from './HauteFire';

const HauteFire = new _HauteFire();

export default class Homepage extends Component {
    constructor() {
        super();

        this.state = {
            HauteDetails: {},
            CategoryDetails: [],
            privateIsland: {},
            isModalShown: false,
            modalContentTitle: "",
            modalContentAbout: ""
        }
    }

    componentDidMount() {
        $("body, html").animate({
            scrollTop: $("#secHomeBanner").position().top
        });

        this.getHauteDetails();
        this.getCategoryDetails();
        // this.getBannerHeight();
        HauteFire.setBanner();

        //Google Analytics
        HauteFire.hauteGoogleAnalytics();
    }

    getBannerHeight() {
        for (let i = 0; i < document.styleSheets.length; i++) {
            if (document.styleSheets[i].title == "style") {
                const classes = document.styleSheets[i].rules || document.styleSheets[i].cssRules;
                if (classes.length > 0) {
                    for (let j = 0; j < classes.length; j++) {
                        if (classes[j].selectorText == ".banner") {
                            const _styles = classes[j].style;
                            const pTop = parseInt(_styles.paddingTop);
                            const pRight = parseInt(_styles.paddingRight);
                            const pBottom = parseInt(_styles.paddingBottom);
                            const pLeft = parseInt(_styles.paddingLeft);
                            const sectionHeight = $("section#secHomeBanner").height();

                            const _height = pTop + pRight + pBottom + pLeft + sectionHeight;
                            const _width = $("section#secHomeBanner").width();
                            $("#imgHomeBanner").css({
                                height: _height + "px",
                                width: _width + "px"
                            });
                            const marginTop = $("section#secHomeBanner").height() + 70;
                            $("div#divExplore").css({'margin-top': "-" + marginTop + "px"});
                        }
                    }
                }
            }
        }
    }

    getHauteDetails() {
        const _this = this;
        let hauteRef = firebase.database().ref("HauteDetails/");
        hauteRef.on('value', ((response) => {
            let HauteDetails = response.val();
            if (HauteDetails != null) {
                let bannerUrl = HauteDetails.bannerPicUrl != undefined ? HauteDetails.bannerPicUrl : HauteDetails.default.bannerPicUrl;
                // $("#secHomeBanner").css({"background-image": "url(" + bannerUrl + ")", "background-size": "cover"});

                let bottomUrl = HauteDetails.bottomPicUrl != undefined ? HauteDetails.bottomPicUrl : HauteDetails.default.bottomPicUrl;
                $("div#secHomeBottom").css({
                    "background": 'url(' + bottomUrl + ') left top no-repeat',
                    "background-size": "cover"
                });

                _this.setState({HauteDetails});
            }
        }))
    }

    getCategoryDetails() {
        const _this = this;
        let categoryRef = firebase.database().ref("CategoryDetails/");
        categoryRef.on('value', ((response) => {
            let CategoryDetails = response.val();
            if (CategoryDetails != null) {
                const keys = Object.keys(CategoryDetails);
                CategoryDetails = keys.map((key) => {
                    return CategoryDetails[key]
                });
                let privateIsland = CategoryDetails.filter((category) => {
                    return category.name.trim().toLowerCase() == "private"
                });
                if (privateIsland.length > 0) {
                    _this.setState({privateIsland: privateIsland[0]});
                }
                _this.setState({CategoryDetails});
            }
        }))
    }

    renderPartners(partner, index) {
        // let anchalStyle = index == 3 ? {marginLeft: '-60px'} : null;

        return (<li key={index}> {partner.title} <a className="more-btn" style={{cursor: 'pointer'}}
                                                                        data-partnerIndex={index}
                                                                        onClick={this.knowMorePartners.bind(this)}>Know
            more <i
                className="icon-more"></i></a></li>);
    }

    renderAdvisoryBoard() {
        const advisory = this.state.HauteDetails.advisoryBoard;
        return (
            <div>
                <span className="advice-board">Advisory Board: <strong>{advisory.title}</strong></span>
                <a className="more-btn" style={{cursor: 'pointer'}} onClick={this.knowMoreAdvisory.bind(this)}>
                    Know more <i className="icon-more"></i></a>
            </div>
        )
    }

    knowMorePartners(e) {
        const _index = e.currentTarget.attributes["data-partnerIndex"].value;
        const partner = this.state.HauteDetails.partners[parseInt(_index)];

        this.setState({isModalShown: true, modalContentTitle: partner.title, modalContentAbout: partner.about});
    }

    knowMoreAdvisory() {
        const advisory = this.state.HauteDetails.advisoryBoard;
        this.setState({isModalShown: true, modalContentTitle: advisory.title, modalContentAbout: advisory.about});
    }

    handleClose() {
        this.setState({isModalShown: false});
    }

    goToIslandDetails(e) {
        const name = e.currentTarget.attributes["data-islandName"].value;
        if (name != "") {
            if (name.trim().toLowerCase().includes("burj")) {
                this.props.history.push("/jumeirah");
            }
            else {
                this.props.history.push("/island/" + name);
            }
        }
    }

    renderIslandLogos(logo) {
        return (<li key={logo.id} data-islandName={logo.islandName} onClick={(e) => this.goToIslandDetails(e)}>
            <a style={{cursor: 'pointer'}}><img src={logo.url} alt={logo.islandName} style={{height: 90}}/></a></li>);
    }

    goToCategoryPage(e) {
        let name = e.currentTarget.attributes["data-name"].value;
        if (name != "") {
            name = name.trim().toLowerCase() == "romance" ? "romantic" : name.trim().toLowerCase();
            this.props.history.push('/' + name + '_islands');
        }
    }

    renderCategories(category, index) {
        if (category.name.trim().toLowerCase() != "private") {
            return (<div className="vacation-kind" key={'cat-' + index}>
                    <figure><img src={category.categoryPics.categoryPicObj.url}
                                 alt={category.name} style={{height: 300}}/></figure>
                    <a className="romance-btn button" data-name={category.name}
                       onClick={(e) => this.goToCategoryPage(e)}
                       style={{cursor: 'pointer'}}>{category.name.trim().toUpperCase()}</a>
                </div>
            )
        }
    }

    scrollToElem(e) {
        const elemId = e.currentTarget.attributes["data-elemId"].value;
        $('html, body').animate({
            scrollTop: $("#" + elemId).offset().top
        }, 2000);
    }

    render() {
        return (
            <div>

                <section id="secHomeBanner" className="sec-banner banner">
                    <img id="imgHomeBanner" className="img-banner bannerpic"
                         src={this.state.HauteDetails.bannerPicUrl}/>
                    <div id="divExplore" className="div-explore hautecontainer">
                        <h1>{!$.isEmptyObject(this.state.HauteDetails) ? this.state.HauteDetails.bannerTitle != undefined ? this.state.HauteDetails.bannerTitle : this.state.HauteDetails.default.bannerTitle : ""}</h1>
                        <span className="banner-content">
                            {!$.isEmptyObject(this.state.HauteDetails) ? this.state.HauteDetails.bannerContent != undefined ? this.state.HauteDetails.bannerContent : this.state.HauteDetails.default.bannerContent : ""}
                        </span>
                        <a className="explore-btn button" style={{cursor: 'pointer'}}
                           data-elemId="explore" onClick={(e) => this.scrollToElem(e)}>explore</a>
                    </div>
                </section>

                <section id="explore" className="vacations-sec">
                    <div className="hautecontainer">
                        <h2>Your Kind Of Vacation</h2>
                        <div className="vacations-content">

                            {!$.isEmptyObject(this.state.privateIsland) ? (<div className="vacation-kind">
                                <figure><img src={this.state.privateIsland.categoryPics.categoryPicObj.url}
                                             alt="Private Island" style={{height: 300}}/></figure>
                                <a className="private-btn button" style={{cursor: 'pointer'}} data-name="private"
                                   onClick={(e) => this.goToCategoryPage(e)}>
                                    PRIVATE ISLANDS</a>
                            </div>) : ""}

                            <div className="clearfix vacations">
                                {this.state.CategoryDetails.length > 0 ? this.state.CategoryDetails.map((category, index) => {
                                    return this.renderCategories(category, index)
                                }) : ""}
                            </div>
                        </div>
                    </div>
                </section>

                <section className="intro-sec">
                    <div className="hautecontainer">
                        <figure className="intro-img-wrap"><img
                            src="../../assets/images/intro.jpg" alt/></figure>
                        <h2 className="intro-head">Who We Are</h2>
                        <p className="intro-detail">
                            {!$.isEmptyObject(this.state.HauteDetails) ? this.state.HauteDetails.aboutUs != undefined ? this.state.HauteDetails.aboutUs : this.state.HauteDetails.default.aboutUs : ""}
                        </p>
                        <ul className="team-nav clearfix">
                            {!$.isEmptyObject(this.state.HauteDetails) ? this.state.HauteDetails.partners.length > 0 ? this.state.HauteDetails.partners.map((partner, index) => {
                                return this.renderPartners(partner, index)
                            }) : "" : ""}
                        </ul>
                        <div>
                            {!$.isEmptyObject(this.state.HauteDetails.advisoryBoard) ? this.renderAdvisoryBoard() : ""}
                        </div>
                    </div>
                </section>

                <div id="secHomeBottom" className="travelling-sec">
                    <div className="hautecontainer">
                        <p className="travel-info">
                            {!$.isEmptyObject(this.state.HauteDetails) ? this.state.HauteDetails.bottomContent != undefined ? this.state.HauteDetails.bottomContent : this.state.HauteDetails.default.bottomContent : ""}
                        </p>
                    </div>
                </div>

                <section className="partner-sec">
                    <div className="hautecontainer">
                        <h2>Our partners</h2>
                        <ul className="pratner-nav clearfix">

                            {!$.isEmptyObject(this.state.HauteDetails.logoUrls) ? this.state.HauteDetails.logoUrls.map((logo) => {
                                return this.renderIslandLogos(logo)
                            }) : ""}


                        </ul>
                    </div>
                </section>

                {this.state.isModalShown ? <ModalContainer onClose={this.handleClose.bind(this)}>
                    <ModalDialog onClose={this.handleClose.bind(this)}>
                        <strong
                            style={{
                                fontWeight: 'bold',
                                fontVariant: 'small-caps'
                            }}>{this.state.modalContentTitle}</strong>
                        <br/>
                        <p>{this.state.modalContentAbout}</p>
                    </ModalDialog>
                </ModalContainer> : ""}

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Homepage.js